module.exports = __webpack_public_path__ + "img/dropdown-arrow.a8d97534.svg";